import { render, staticRenderFns } from "./OrderAddress.vue?vue&type=template&id=2127bf33&"
import script from "./OrderAddress.vue?vue&type=script&lang=js&"
export * from "./OrderAddress.vue?vue&type=script&lang=js&"
import style0 from "./OrderAddress.vue?vue&type=style&index=0&id=2127bf33&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports